import store from '@/store'
import _ from 'lodash'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

// 注文詳細画面モード
const INPUT_TYPE = Object.freeze(
  {
    TEXT: 1,              // テキストボックス
    MULTI_LINE_TEXT: 2,   // 複数行テキストボックス
    MULTI_TEXT: 3,        // 複数テキストボックス
    HTML: 4,              // htmlテキストボックス
    NUMBER: 5,            // 数値
    DATE: 6,              // 日付
    DATETTIME: 7,         // 日時
    SELECT: 8,            // 単一選択
    MULTI_SELECT: 9,      // 複数選択
    OBJECT_ARRAY: 10,     // オブジェクト配列
    CHECK_BOX: 11,        // チェックボックス
    MULTI_NUMBER: 12,     // 複数テキストボックス(数値)
    DATE_MILLI_SECONDS: 13,           // 日付（ミリ秒）
    DATETIME_MILLI_SECONDS: 14        // 日時（ミリ秒）
  }
)
export default {
  /**
   * カスタマイズ設定マスタを元に画面表示するカスマム属性の要素を返却する
   * @param {*} displayItem 商品データ
   * @param {*} customizeObj カスタマイズ設定マスタ
   * @param {*} attributePath 属性配列パス
   * @param {*} editableId 編集可否ID（ベースは親項目の属性ID）
   * @param {*} storePath 画面のストアパス
   * @param {*} dataStorePath 商品情報のストアパス
   * @param {*} pPermKey 親権限ID
   * @param {*} param 再帰処理用
   * @returns {Object} 表示用プロパティ
   */
  getCustomizeColumn (displayItem, customizeObj, attributePath, editableId, storePath, dataStorePath, pPermKey = null, { isChild = false, parentInstance = null, parentInstancePath = '', pathFromParent = '' } = {}) {
    // 処理内容が煩雑で処理フローを理解しやすくするため、処理を事前に書き出す

    /**
     * 親権限と子権限の強さを比較。子権限キーの利用可否を返却する。
     *  親権限 >= の場合は子権限キーをそのまま利用してよいが、
     *  逆転している場合は親権限の許可範囲内の制御とする必要がある。
     * @param {String} pPermKey 親のカスタム属性権限キー
     * @param {*} pPerm 親権限
     * @param {*} cPerm 子権限
     * @returns {Boolean} true: 子権限キー利用可, false: 子権限キー利用不可（親権限キーを利用）
     */
    const allowsUseCPerm = (pPermKey, pPerm, cPerm) => {
      // 正規表現ルールを作成（[...attribute_*] に一致するもの）
      const reg = new RegExp(`${pPermKey}_.*$`)
      // 子のカスタム属性の権限設定の存在有無を返却する（存在する場合は true）
      const existsCPerm = Object.keys(store.state.role).some((k) => {
        return k.match(reg)
      })
      // 子権限設定がないため、親権限キーを設定
      if (existsCPerm === false) {
        return false
      }
      // null の場合は非表示なので、一番弱い権限として -1 として扱う（表示: 1, 表示のみ: 0, 非表示: null）
      const a = pPerm == null ? -1 : pPerm
      const b = cPerm == null ? -1 : cPerm
      if (a >= b) {
      // 親権限が強い or 同じなため、子権限を設定
        return true
      } else if (a < b) {
      // 子権限の方が強いので、親権限を設定
        return false
      } else {
      // 権限値が不正な場合はエラー
        throw new Error('関数名: isAllowChildPerm 権限値が不正です。')
      }

    }

    const returnObject = {}
    returnObject.label = customizeObj.attributeName
    returnObject.properties = []

    let property = {}
    // attributes配列のインデックス
    let index = -1
    property.validateAs = customizeObj.attributeName

    // パス、編集可否、機能IDを設定する（登録要素の追加等で displayItem も操作する）
    if (isChild) {
    // 再帰処理（子項目）の場合

      property.path = customizeObj.attributeKey
      property.editableId = editableId
      property.funcId = pPermKey
      if (displayItem[customizeObj.attributeKey] == null) {
        // 登録用に undefined を null する
        // ※ (JSONオブジェクトの子であり、取り扱いしやすいように通常の attribute とは形式が異なる)
        displayItem[customizeObj.attributeKey] = null
      }
      // 子要素用の商品データを設定する（変更時は change イベントで元データを変更している）
      property.displayItem = displayItem

    } else {
    // 再帰処理（子項目）以外

      // property.path 設定
      // attributes 配列の中の何番目に指定のカスタム属性データがあるか取得
      //  データイメージ：attributes: [{ attributeId: 'id1', attributeValue: 'value1' }, { attributeId: 'id2', attributeValue: 'value2' }...]
      index = (displayItem[attributePath] || [])
        .findIndex((element) => element.attrId === customizeObj.attributeKey)

      if (index >= 0) {
      // インデックスを取得できた場合、パスに設定
        property.path = `${attributePath}.${index}.attrValue`
      } else {
      // インデックスを取得できない場合、attributes配列の存在を確認
        if (displayItem[attributePath] != null) {
        // 配列が存在する場合、登録用に末尾に要素を追加してパスに設定
          index = displayItem[attributePath].length
          // 登録用の要素を追加
          displayItem[attributePath].push({ attrId: customizeObj.attributeKey, attrValue: null })
          property.path = `${attributePath}.${index}.attrValue`
        } else {
        // 配列が存在しない場合、処理を終了
          return returnObject
        }
      }

      property.editableId = customizeObj.attributeKey

      // property.funcId 設定
      // 自身の権限キーを取得する
      //  （カスタマイズ属性マスタのキーはキャメルケースのため、スネークケースに変換して親権限IDと結合）
      const myPermKey = `${pPermKey}_${_.snakeCase(customizeObj.attributeKey)}`
      // 親子の権限設定の値を取得
      const pPerm = store.state.role[pPermKey]
      const cPerm = store.state.role[myPermKey]
      if (allowsUseCPerm(pPermKey, pPerm, cPerm)) {
      // 子権限利用可の場合、自身の権限キーを設定
        property.funcId = myPermKey
      } else {
      // 子権限利用負荷の場合、親権限キーを設定
        property.funcId = pPermKey
      }

    }

    property.validateRule = 'max:6000'
    if (customizeObj.isRequired) {
      property.validateRule += '|required'
    }

    // 表示用プロパティ構成処理
    switch (customizeObj.inputType) {
      case INPUT_TYPE.TEXT: // テキストボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT
        break
      case INPUT_TYPE.MULTI_LINE_TEXT: // 複数行テキストボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT_TEXT_AREA
        property.rows = 5
        property.class = 'multiLineTextBox'
        property.lineBreak = true
        break
      case INPUT_TYPE.MULTI_TEXT: // 複数テキストボックス（テキスト。内部データ：「"」括り。「,」区切り。）
      case INPUT_TYPE.MULTI_NUMBER: // 複数テキストボックス（テキスト。内部データ：「"」括り。「,」区切り。）
        // 最大文字数の対応
        // BASECELLのプロパティがメソッドの場合、実行した値になるように回収しておく
        property.elementType = ELEMENT_TYPE.CELL
        property.class = 'valueArray'
        property.editableId = isChild ? editableId : customizeObj.attributeKey
        property.properties = (displayItem, displayValue, editable) => {
          const property = []
          // カンマ区切りで配列分のCELLをを作成
          let values
          if (isChild) {
            values = displayValue || null
          } else {
            values = displayValue ? JSON.parse(displayValue) : null
          }
          if (values == null || values.length === 0) {
            values = ['']
            displayValue = JSON.stringify(values)
          }
          values.forEach((value, arrayIndex) => {
            // テキストボックス + 削除ボタンの形式でCELLのプロパティを作成
            let propertiesData = [{
              type: customizeObj.inputType === INPUT_TYPE.MULTI_TEXT ? 'String' : 'Number',
              elementType: customizeObj.inputType === INPUT_TYPE.MULTI_TEXT ? ELEMENT_TYPE.INPUT : ELEMENT_TYPE.INPUT_NUMBER,
              path: 'value',
              validateAs: customizeObj.attributeName,
              validateRule: 'max:6000',
              displayItem: { value },
              change: (event) => {
                if (isChild) {
                  const values = JSON.parse(parentInstance)
                  const val = _.get(values, pathFromParent) || ['']
                  if (val[arrayIndex] != null) {
                    val[arrayIndex] = event
                  }
                  _.set(values, pathFromParent, val)
                  store.dispatch({
                    type: 'set',
                    states: {
                      [parentInstancePath]: JSON.stringify(values)
                    }
                  })
                } else {
                  const values = JSON.parse(displayValue)
                  values[arrayIndex] = event
                  store.dispatch({
                    type: 'set',
                    states: {
                      [`${dataStorePath}/${attributePath}/${index}/attrValue`]: JSON.stringify(values)
                    }
                  })
                }
              },
              editableId: isChild ? editableId : customizeObj.attributeKey
            }]
            if (editable && values.length > 1) {
              propertiesData.push({
                type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'delBtn',
                icon: 'fas fa-times-circle', path: 'value',
                displayItem: { value },
                editableId: isChild ? editableId : customizeObj.attributeKey,
                click: (event, displayItem, inputValue) => {
                  if (isChild) {
                    const values = JSON.parse(parentInstance)
                    const val = _.get(values, pathFromParent) || ['']
                    if (val != null) {
                      val.splice(arrayIndex, 1)
                    }
                    _.set(values, pathFromParent, val)
                    store.dispatch({
                      type: 'set',
                      states: {
                        [parentInstancePath]: JSON.stringify(values)
                      }
                    })
                  } else {
                    const values = JSON.parse(displayValue)
                    values.splice(arrayIndex, 1)
                    store.dispatch({
                      type: 'set',
                      states: {
                        [`${dataStorePath}/${attributePath}/${index}/attrValue`]: JSON.stringify(values)
                      }
                    })
                  }
                }
              })
            }
            if (editable && (values.length === arrayIndex + 1)) {
              propertiesData.push({
                type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
                icon: 'fas fa-plus-circle', path: 'value',
                displayItem: { value },
                editableId: isChild ? editableId : customizeObj.attributeKey,
                size: 'small',
                click: (event, displayItem, inputValue) => {
                  if (isChild) {
                    const values = JSON.parse(parentInstance)
                    const val = _.get(values, pathFromParent) || ['']
                    val.push('')
                    _.set(values, pathFromParent, val)
                    store.dispatch({
                      type: 'set',
                      states: {
                        [parentInstancePath]: JSON.stringify(values)
                      }
                    })
                  } else {
                    const values = JSON.parse(displayValue)
                    values.push('')
                    store.dispatch({
                      type: 'set',
                      states: {
                        [`${dataStorePath}/${attributePath}/${index}/attrValue`]: JSON.stringify(values)
                      }
                    })
                  }
                }
              })
            }
            property.push({
              // カスタムタイプのセルを指定
              type: 'String', elementType: ELEMENT_TYPE.CELL,
              validateRule: `|customMaxLengthValue:${displayValue}`,
              properties: propertiesData,
              index: index,
              horizontal: true
            })
          })

          return property
        }
        break
      case INPUT_TYPE.HTML: // htmlテキストボックス（プレビュー付き）
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT_TEXT_AREA
        property.rows = 4
        property.class = 'multiLineTextBox'
        property.lineBreak = true
        returnObject.properties.push(property)

        // プレビューボタン
        property = {
          id: 'previewBtn',
          type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'previewBtn',
          icon: '', size: 'small', label: 'プレビュー',
          path: `${attributePath}.${index}.attrValue`,
          click: (event, displayItem, displayValue) => {
            store.dispatch({
              type: 'set',
              states: {
                [`${storePath}/htmlPreviewDialogVisible`]: true,
                [`${storePath}/htmlPreviewDialogContent`]: displayValue
              }
            })
          }
        }

        break
      case INPUT_TYPE.NUMBER: // 数値
        property.type = 'Number'
        property.elementType = ELEMENT_TYPE.INPUT_NUMBER
        break
      case INPUT_TYPE.DATE: // 日付
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE
        property.dateFormat = 'YYYY/MM/DD'
        break
      case INPUT_TYPE.DATE_MILLI_SECONDS:            // 日付（ミリ秒）
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE_MILLI_SECONDS
        property.dateFormat = 'YYYY/MM/DD'
        break
      case INPUT_TYPE.DATETTIME: // 日時
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE_TIME
        property.dateFormat = 'YYYY/MM/DD HH:mm:ss'
        break
      case INPUT_TYPE.DATETIME_MILLI_SECONDS:        // 日時（ミリ秒）
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATETIME_MILLI_SECONDS
        property.dateFormat = 'YYYY/MM/DD HH:mm:ss'
        break
      case INPUT_TYPE.CHECK_BOX: // チェックボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.CHECK_BOX
        property.change = (displayItem) => {
          displayItem = Number(displayItem)
        }
        break
      case INPUT_TYPE.SELECT: // 単一選択
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.SELECT_BOX
        property.clearable = true
        property.codeName = customizeObj.optionKey
        property.selectCode = customizeObj.optionKey
        break
      case INPUT_TYPE.MULTI_SELECT: // 複数選択
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.SELECT_BOX
        property.multiple = true
        property.codeName = customizeObj.optionKey
        property.selectCode = customizeObj.optionKey
        break
      case INPUT_TYPE.OBJECT_ARRAY: // オブジェクト配列 1階層下のみ対応
        property.class = 'valueObjectArray'
        property.elementType = ELEMENT_TYPE.CELL
        property.editableId = isChild ? editableId : customizeObj.attributeKey

        const newEmptyChildObject = () => {
          const returnObject = {}
          customizeObj.childCustomizeProperty.forEach((child, childIndex) => {
            // 項目名
            returnObject[child.attributeKey] = null
          })
          return returnObject
        }
        if (displayItem[attributePath][index].attrValue == null) {
          displayItem[attributePath][index].attrValue = JSON.stringify([])
        }

        property.properties = (propDisplayItem, displayValue, editable) => {
          const childProperties = []
          let objectArrayValue = displayValue ? JSON.parse(displayValue) || [] : []

          // データ配列分
          objectArrayValue.forEach((objectValue, objectIndex) => {
            // 子オブジェクト分
            customizeObj.childCustomizeProperty.forEach((child, childIndex) => {
              const childCell = {
                elementType: ELEMENT_TYPE.CELL,
                horizontal: true,
                properties: []
              }

              // 項目名
              childCell.properties.push({
                type: 'string', displayItem: { title: `${child.attributeName}：` },
                path: 'title', class: 'itemLabel'
              })

              // 項目の値
              const newEmptyObject = this.getCustomizeColumn(objectValue, child,
                child.attributeKey, customizeObj.attributeKey,
                storePath, `${child.attributeKey}`, property.funcId,
                {
                  isChild: true,
                  parentInstancePath: `${dataStorePath}/${attributePath}/${index}/attrValue`,
                  parentInstance: displayValue,
                  pathFromParent: `${objectIndex}.${child.attributeKey}`
                })

              newEmptyObject.class = 'itemValue'
              newEmptyObject.change = (event) => {
                const values = JSON.parse(displayValue)
                values[objectIndex][child.attributeKey] = event
                store.dispatch({
                  type: 'set',
                  states: {
                    [`${dataStorePath}/${attributePath}/${index}/attrValue`]: JSON.stringify(values)
                  }
                })
              }
              newEmptyObject.validateRule = `customMaxLengthValue:${displayItem[attributePath][index].attrValue}`

              childCell.properties.push(newEmptyObject)

              childProperties.push(childCell)
            })

            const btnCell = {
              elementType: ELEMENT_TYPE.CELL,
              horizontal: true,
              properties: []
            }

            // 削除ボタン
            if (editable && objectArrayValue.length > 0) {
              btnCell.properties.push({
                type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'delBtn',
                icon: 'fas fa-times-circle', path: 'value',
                displayItem: { objectValue },
                editableId: isChild ? editableId : customizeObj.attributeKey,
                click: (event, displayItem, inputValue) => {
                  const values = JSON.parse(displayValue)
                  values.splice(objectIndex, 1)
                  store.dispatch({
                    type: 'set',
                    states: {
                      [`${dataStorePath}/${property.path}`]: JSON.stringify(values)
                    }
                  })
                }
              })
            }
            // 追加ボタン（最後であれば）
            if (editable && (objectArrayValue.length === objectIndex + 1)) {
              btnCell.properties.push({
                type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
                icon: 'fas fa-plus-circle', path: 'value',
                editableId: isChild ? editableId : customizeObj.attributeKey, size: 'small',
                click: (event, displayItem, inputValue) => {
                  const values = JSON.parse(displayValue)
                  values.push(newEmptyChildObject())
                  store.dispatch({
                    type: 'set',
                    states: {
                      [`${dataStorePath}/${property.path}`]: JSON.stringify(values)
                    }
                  })
                }
              })
            }
            if (btnCell.properties.length > 0) childProperties.push(btnCell)
          })
          // 追加ボタン（最後であれば）
          if (editable && objectArrayValue.length === 0) {
            const btnCell = {
              elementType: ELEMENT_TYPE.CELL,
              horizontal: true,
              properties: []
            }
            btnCell.properties.push({
              type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
              icon: 'fas fa-plus-circle', path: 'value',
              editableId: isChild ? editableId : customizeObj.attributeKey, size: 'small',
              click: (event, displayItem, inputValue) => {
                const values = []
                values.push(newEmptyChildObject())
                store.dispatch({
                  type: 'set',
                  states: {
                    [`${dataStorePath}/${property.path}`]: JSON.stringify(values)
                  }
                })
              }
            })
            childProperties.push(btnCell)
          }

          return childProperties
        }
        break
    }

    if (isChild) {
      return property
    } else {
      returnObject.properties.push(property)
      return returnObject
    }
  },

  getCustomizeEmptyColumn () {
    const returnObject =
      {
        label: '　',
        properties: [{}]
      }

    return returnObject
  },
  getCustomizeListColumn (customizeObj, index) {
    const property = {
      label: customizeObj.attributeName,
      columnKey: 'attribute',
      path: `attributes.${index}.attrValue`
    }

    switch (customizeObj.inputType) {
      case INPUT_TYPE.TEXT: // テキストボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT
        break
      case INPUT_TYPE.MULTI_LINE_TEXT: // 複数行テキストボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT_TEXT_AREA
        property.rows = 5
        property.class = 'multiLineTextBox'
        property.lineBreak = true
        break
      case INPUT_TYPE.NUMBER: // 数値
        property.type = 'Number'
        property.elementType = ELEMENT_TYPE.INPUT_NUMBER
        break
      case INPUT_TYPE.DATE: // 日付
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE
        property.dateFormat = 'YYYY/MM/DD'
        break
      case INPUT_TYPE.DATETTIME: // 日時
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE_TIME
        property.dateFormat = 'YYYY/MM/DD HH:mm:ss'
        break
      case INPUT_TYPE.CHECK_BOX: // チェックボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.CHECK_BOX
        break
      case INPUT_TYPE.SELECT: // 単一選択
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.SELECT_BOX
        property.codeName = customizeObj.optionKey
        property.selectCode = customizeObj.optionKey
        break
      case INPUT_TYPE.MULTI_SELECT: // 複数選択
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.SELECT_BOX
        property.multiple = true
        property.codeName = customizeObj.optionKey
        property.selectCode = customizeObj.optionKey
        break
    }
    return property
  },
  getDefaultValue (customizeObj) {
    switch (customizeObj.inputType) {
      case INPUT_TYPE.TEXT: // テキストボックス
      case INPUT_TYPE.MULTI_LINE_TEXT: // 複数行テキストボックス
        return ''
      case INPUT_TYPE.NUMBER: // 数値
        return 0
      case INPUT_TYPE.DATE: // 日付
        return null
      case INPUT_TYPE.DATETTIME: // 日時
        return null
      case INPUT_TYPE.CHECK_BOX: // チェックボックス
        return 0
      case INPUT_TYPE.SELECT: // 単一選択
        return null
      case INPUT_TYPE.MULTI_SELECT: // 複数選択
        return []
    }
  }
}
